export default __webpack_public_path__ + "static/O0094-e3bc0a075ba125d0ff3716684eb66c0b.png";